import React from "react"

import { Trans } from "#modules/localization/trans.server"

// Allows inline usage of <br> <i> <strong> etc in translations (from Trans component) & adds custom inline components for styling header/body text
export const TransBasicFormat: typeof Trans = props => {
  return (
    <Trans
      {...props}
      components={{
        ...props.components,
        highlight: <span className="text-gold-100" />,
        highlightDark: <span className="text-gold-150" />,
      }}
    />
  )
}
